module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("inventory_managment")]) : _vm._e(), _vm._v(" "), _c('div', {
    class: ' container_auto '
  }, [_c('search-control', {
    staticStyle: {
      "padding-bottom": "10px",
      "width": "100%"
    },
    attrs: {
      "field_names": _vm.allSearchFields
    },
    on: {
      "onSearchClear": _vm.onSearchClear,
      "change": _vm.searchControlChangedDatasource
    }
  }), _vm._v(" "), _c('ag-grid-vue', {
    staticClass: "ag-blue",
    staticStyle: {
      "width": "100%",
      "height": "325px",
      "margin-left": "-15px"
    },
    attrs: {
      "gridOptions": _vm.gridOptions
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "margin-top": "5px"
    }
  }, [_vm._v("\n          件数　\n          ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control limited-height-box",
    staticStyle: {
      "width": "5%",
      "text-align": "right"
    },
    attrs: {
      "type": "text",
      "data-cy": "totalNumberOfRows",
      "disabled": true
    },
    domProps: {
      "value": _vm.totalNumberOfRows
    }
  }), _vm._v(" "), _c('device-management-ledger-modal', {
    attrs: {
      "tag": "showInventoryManagmentModal"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "col-xs-6"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-right": "-15px",
      "background": "#337ab7"
    },
    attrs: {
      "disabled": true || _vm.checkUserPermission(true, _vm.permissionMode.EXPORT) == false
    }
  }, [_vm._v("出力")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-right": "10px"
    },
    attrs: {
      "disabled": _vm.checkUserPermission(_vm.acl.inventory_report_check, _vm.permissionMode.EXPORT) == false,
      "tag": "button",
      "to": "/inventory_report_check",
      "type": "button"
    }
  }, [_vm._v("棚卸報告確認")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "7%",
      "float": "right",
      "margin-right": "10px",
      "background": "#92D050",
      "border-color": "#92D050"
    },
    attrs: {
      "disabled": _vm.checkUserPermission(_vm.acl.inventory_report, _vm.permissionMode.EXPORT) == false
    },
    on: {
      "click": _vm.addNewReport
    }
  }, [_vm._v("棚卸報告")])], 1)]), _vm._v(" "), _c('br')])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47f00d80","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sub_pages/inventory_management.vue
// module id = 978
// module chunks = 0